var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"container"},[_c('el-container',{staticClass:"main-content"},[_c('el-main',{staticClass:"main",attrs:{"id":"layout-main"}},[_c('Measure')],1),_c('el-aside',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hide),expression:"!hide"}],staticClass:"aside-right",attrs:{"width":"320px"}},[_c('RightBlock')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }